import React from 'react';
import './TopNavBar.css';

const TopNavBar = () => {
    return (
        <header className="main-header " id="header">
            <nav className="navbar navbar-static-top navbar-expand-lg">

            </nav>
        </header>
    )
}
export default TopNavBar;